export const AuthenticationTypes = {
    AzureActiveDirectory: "azure_active_directory",
    BasicAuthentication: "basic_authentication",
    Okta: "okta"
};